import Applications from '@/api/applications'
import Jobs from '@/api/jobs'
import Price from '@/api/price'

export default {
  namespaced: true,
  state: {
    applications: [],
    jobApplications: [],
    current: null,
    currentJob: null,
    currentReferral: null,
    currentTally: {},
    currentOfferSalary: null,
    currentOfferStartDate: null,
    currentPrice: 0.0001,
    interviewMessage: '',
    searchApplication: ''
  },
  getters: {
    applicant: (state) => {
      return {
        firstName: state.current.applicantFirstName,
        lastName: state.current.applicantLastName,
        location: state.current.applicantLocation,
        role: state.current.applicantRole,
        companyName: state.current.applicantCompanyName
      }
    },
    canMakeOffer: (state) => {
      if (!state.current) return
      if (
        state.current.status !== 'interviewing' &&
        state.current.status !== 'offered'
      ) {
        return false
      }

      if (!state.currentOfferSalary || !state.currentOfferStartDate) {
        return false
      }

      return true
    },
    hvtReward: (state) => {
      if (!state.current || !state.currentPrice || !state.currentOfferSalary) {
        return '0.000'
      }
      const salary = state.currentOfferSalary
      const ratio = 0.045
      return (salary * ratio) / state.currentPrice
    }
  },
  mutations: {
    setSearchApplication (state, searchApplication) {
      state.searchApplication = searchApplication
    },
    setApplications (state, applications) {
      state.applications = applications
    },
    setCurrentApplication (state, current) {
      state.current = current
      state.currentOfferStartDate = null
      state.currentOfferSalary = null
    },
    setCurrentApplicationOffer (state, current) {
      state.current = current
    },
    setCurrentReferral (state, referral) {
      state.currentReferral = referral
    },
    setJobApplications (state, applications) {
      state.jobApplications = applications
    },
    setCurrentJob (state, currentJob) {
      state.currentJob = currentJob
    },
    setCurrentOfferSalary (state, salary) {
      state.currentOfferSalary = salary
    },
    setCurrentOfferStartDate (state, startDate) {
      state.currentOfferStartDate = startDate
    },
    updateApplicationState (state, data) {
      const id = data.id
      const status = { data }
      const index = state.applications.findIndex(x => x.id === id)
      if (index < 0) { return }
      state.applications[index].status = status
    },
    setCurrentTally (state, tally) {
      state.currentTally = tally
    },
    setCurrentPrice (state, price) {
      state.currentPrice = price
    },
    setInterviewMessage (state, interviewMessage) {
      state.interviewMessage = interviewMessage
    }

  },
  actions: {
    async getAll ({ commit }) {
      const xs = await Applications.getAll()
      commit('setApplications', xs)
    },
    async getState ({ commit }, state) {
      const xs = await Applications.getState(state)
      commit('setApplications', xs)
    },
    async updateState ({ commit }, { id, state }) {
      await Applications.update(id, { status: state, skipping: true, message: '' })
      commit('updateApplicationState', { id, status: state })
    },
    async updatePrice ({ commit }) {
      const price = await Price.getCurrentPrice()
      commit('setCurrentPrice', price)
    },
    async getApplicationsForJob ({ commit }, { jobId, state }) {
      if (jobId === 'null' || !jobId) return
      const job = await Jobs.get(jobId)
      const applications = await Applications.getApplicationsForJob({
        jobId, state
      })
      const tally = await Applications.getTally({ jobId })
      commit('setCurrentJob', job)
      commit('setJobApplications', applications)
      commit('setCurrentTally', tally)
    },
    async updateTally ({ commit }, jobId) {
      const tally = await Applications.getTally({ jobId })
      commit('setCurrentTally', tally)
    },
    async sendOffer ({ commit, state }) {
      const id = state.current.id
      const salary = state.currentOfferSalary
      const startDate = state.currentOfferStartDate
      await Applications.sendOffer(id, {
        salary, startDate
      })
      commit('updateApplicationState', { id, status: 'offered' })
    },
    async reject ({ commit, state }, reason) {
      const id = state.current.id
      await Applications.reject(id, {'reason': reason})
      commit('updateApplicationState', { id, status: 'rejected' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin-applications.js